
import {defineComponent, ref, onMounted} from 'vue'
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import axios from "axios";
import { useRoute } from 'vue-router'
import router from "@/router";

export default defineComponent({
  name: 'OpenGame',
  components: {
    LoaderWrapper
  },
  setup() {
    const loaderWrapper = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const route = useRoute()

    const openGame = () => {
      loaderWrapper.value?.show();
      axios({
        url: '/vendors/' + route.params.vendorId + '/games/' + route.params.gameId + window.location.search,
        method: 'GET',
      }).then((resp) => {
        window.location.replace(resp.data.url);
        setTimeout(() => loaderWrapper.value?.hide(), 2000);
      }).catch(() => {
        loaderWrapper.value?.hide();
      })
    }


    onMounted(() => {
      openGame();
    });

    return {
      loaderWrapper,
      openGame
    }
  }
})
